// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '130.89px',
  height: '127.48px',
  className: null,
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

// Component
function IconQuestion({ width, height, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 130.89 127.48"
    >
      <path
        fill="#0070f2"
        opacity="0.148"
        d="M70.718,0c27.865,0,30.189,6.365,30.189,33.384S74.682,74.471,50.453,82.308,0,60.4,0,33.384,42.853,0,70.718,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 50.302, 0)"
      />
      <g transform="translate(44.446 4.881)">
        <path
          fill="#0f7eff"
          d="M104.355,36.219A36.218,36.218,0,1,0,58.189,71.051a5.446,5.446,0,0,1,3.236,2.507l4.6,7.976a2.438,2.438,0,0,0,4.225,0l4.6-7.976a5.443,5.443,0,0,1,3.234-2.506A36.232,36.232,0,0,0,104.355,36.219Z"
          transform="translate(-31.918 0)"
        />
        <path
          fill="#0056bf"
          d="M235.744,0q-1.818.013-3.591.2a36.223,36.223,0,0,1,6.09,70.846,5.443,5.443,0,0,0-3.234,2.506l-2.857,4.955,1.742,3.022a2.438,2.438,0,0,0,4.225,0l4.6-7.976a5.443,5.443,0,0,1,3.234-2.506A36.223,36.223,0,0,0,235.744,0Z"
          transform="translate(-199.788 0)"
        />
        <path
          fill="#fff"
          d="M238.85,314.889h-2.094a2.461,2.461,0,0,1-2.461-2.461v-1.687a2.461,2.461,0,0,1,2.461-2.461h2.094a2.461,2.461,0,0,1,2.461,2.461v1.687A2.461,2.461,0,0,1,238.85,314.889Z"
          transform="translate(-201.585 -258.453)"
        />
        <g transform="translate(24.522 14.853)">
          <path
            fill="#fff"
            d="M195.332,122.352a3.224,3.224,0,0,1-3.224-3.224v-7.065a3.224,3.224,0,0,1,3.224-3.224,5.249,5.249,0,1,0-5.249-5.249,3.224,3.224,0,1,1-6.447,0,11.7,11.7,0,1,1,15.145,11.177.32.32,0,0,0-.225.305v4.055A3.224,3.224,0,0,1,195.332,122.352Z"
            transform="translate(-183.636 -91.894)"
          />
        </g>
      </g>
    </svg>
  )
}

IconQuestion.defaultProps = defaultProps
IconQuestion.propTypes = propTypes

export default IconQuestion
